module.exports = __webpack_public_path__ + "static/scale-model-of-garland-texas-d0c8b3f3e32c859d03268a0714ade36e.png";